export default "__VITE_ASSET__CnY19Xeh__"